import { render, staticRenderFns } from "./DivInfoCall.vue?vue&type=template&id=b95f1648&scoped=true&lang=pug&"
import script from "./DivInfoCall.vue?vue&type=script&lang=js&"
export * from "./DivInfoCall.vue?vue&type=script&lang=js&"
import style0 from "./DivInfoCall.vue?vue&type=style&index=0&id=b95f1648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f1648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95f1648')) {
      api.createRecord('b95f1648', component.options)
    } else {
      api.reload('b95f1648', component.options)
    }
    module.hot.accept("./DivInfoCall.vue?vue&type=template&id=b95f1648&scoped=true&lang=pug&", function () {
      api.rerender('b95f1648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/silver/components/DivInfoCall.vue"
export default component.exports